module.exports = __webpack_public_path__ + "img/icon-layout-grid.acfcf9c0.svg";